export class ProjectDataExtensions {
    static hasPublished(projectDetails) {
        if (typeof projectDetails.reRoutes === "undefined")
            return false;
        if (projectDetails.reRoutes === null)
            return false;
        return projectDetails.reRoutes.findIndex(rr => {
            return rr.published;
        }) !== -1;
    }
}
